import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const FIND_THE_LETTER_ACTIVITY_FRAGMENT = gql `
  fragment FindTheLetterActivityFragment on FindTheLetterActivity {
    rounds {
      id
      letter
      selectLetterInstructions {
        id
        audio {
          ...AssetFragment
        }
        text
      }
      typeLetterInstructions {
        id
        audio {
          ...AssetFragment
        }
        text
      }
      steps {
        id
        word
        wordImage {
          id
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default FIND_THE_LETTER_ACTIVITY_FRAGMENT;
